import React, { useReducer, useEffect } from "react";
import { useLocation } from "react-router";

import {
  CLIENT_TYPES,
  CLIENT_FORM,
  CUSTOM_CONF_FIELDS,
  CLIENT_REDUCER_ACTIONS,
} from "../../constants/client";
import { usePostApi } from "../../hooks";
import { Loader } from "../../components";
import reducer, { initState } from "../../reducers/client";
import FullPageError from "../../components/fullPageError";

import ClientTiles from "./clientTiles";
import ClientCurrent from "./clientCurrent";
import ClientNew from "./clientNew";

const { UPDATE_CLIENT_FIELD } = CLIENT_REDUCER_ACTIONS;
const { CLIENT_TYPE } = CLIENT_FORM;

const ClientSelection = () => {
  const location = useLocation();
  const [client, setClient] = useReducer(reducer, {
    ...initState,
    ...location.state?.client,
  });

  const prepareCall = usePostApi(
    "/brokerportal/v1/prepareClientForm",
    {},
    null,
  );

  useEffect(() => {
    if (prepareCall.data?.brokerClientInfoConfig) {
      setClient({
        type: UPDATE_CLIENT_FIELD,
        name: CUSTOM_CONF_FIELDS,
        value: prepareCall.data.brokerClientInfoConfig,
      });
    }
  }, [prepareCall.data]);

  const renderBody = () => {
    switch (client[CLIENT_TYPE]) {
      case CLIENT_TYPES.CURRENT_CLIENT:
        return (
          <ClientCurrent
            {...prepareCall}
            client={client}
            setClient={setClient}
          />
        );
      case CLIENT_TYPES.NEW_CLIENT:
      case CLIENT_TYPES.PROSPECT_CLIENT:
        return (
          <ClientNew {...prepareCall} client={client} setClient={setClient} />
        );
      default:
        return <ClientTiles client={client} setClient={setClient} />;
    }
  };

  return prepareCall?.loading ? (
    <Loader />
  ) : prepareCall?.error ? (
    <FullPageError
      error="We are having trouble retrieving your client data"
      onClick={() => prepareCall.dispatchCall()}
    />
  ) : (
    renderBody()
  );
};

export default ClientSelection;
